if (!customElements.get('scroll-to-link')) {
  customElements.define(
    'scroll-to-link',
    class ScrollToLink extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.link = this.querySelector('a[href^="#"]');
        if (this.link) this.link.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.link) this.link.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        const target = document.getElementById(decodeURIComponent(this.link.hash.slice(1)));
        if (!target) return;

        event.preventDefault();
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        // Move focus so keyboard and screen reader users continue from the reviews.
        target.focus({ preventScroll: true });
        history.pushState(null, '', this.link.hash);
      }
    }
  );
}
